import React from "react";
import { Row, Col, Container } from "react-bootstrap";

const SubmitFormPreview = ({
  type,
  size,
  name,
  color,
  icon,
  image,
  main_text,
  bottom_text,
  headerText,
  birthDate,
  deathDate,
  text_top,
}) => {
  let modalStyle = {
    backgroundColor: "white",
    height: "auto",
    padding: "0",
    width: "100%",
    border: `5px solid ${
      color && color === "blue"
        ? "blue" // Use the specific color for "blue"
        : color === "green" || color === "black" || color === "red"
        ? color // Use other colors for "green," "black," or "red"
        : "black" // Default color for other cases
    }`,
  };

  if (type === "Umrlica") {
    modalStyle.border = `5px solid ${
      color && color === "blue"
        ? "blue" // Use the specific color for "blue"
        : color === "green" || color === "black" || color === "red"
        ? color // Use other colors for "green," "black," or "red"
        : "black" // Default color for other cases
    }`;
  } else if (type === "Pomen") {
    modalStyle.border = "7px double black";
  } else if (type === "Poslednji pozdrav") {
    modalStyle.border = "3px solid black";
  }

  // Use a conditional statement to set the font size based on the size
  if (size === "Najmanja") {
    modalStyle.fontSize = "14px";
  } else if (size === "Mala") {
    modalStyle.fontSize = "16px";
  } else if (size === "Srednja") {
    modalStyle.fontSize = "16px";
  } else if (size === "Velika") {
    modalStyle.fontSize = "17px";
  }

  if (size === "Najmanja") {
    modalStyle.width = "45%";
  } else if (size === "Mala") {
    modalStyle.width = "40%";
  } else if (size === "Srednja") {
    modalStyle.width = "55%";
    modalStyle.minHeight = "650px";
  } else if (size === "Velika") {
    modalStyle.width = "100%";
    modalStyle.minHeight = "650px";
  }

  return (
    <Container className="post" style={modalStyle} lg={6} sm={12} md={12}>
      {size === "Mala" && type === "Poslednji pozdrav" && (
        <p style={{ textAlign: "center", paddingTop: "1%" }}>{text_top}</p>
      )}
      {size === "Velika" && (
        <p style={{ textAlign: "center", paddingTop: "1%" }}>{text_top}</p>
      )}
      {size === "Srednja" && (
        <Col
          style={{ marginTop: "30px" }}
          className="d-flex justify-content-center"
        >
          <img
            id="umrlica-icon"
            style={{
              height: "60px",
              width: "60px",
              border: "none",
              marginBottom: "1%",
            }}
            src={icon}
            alt="x"
          />
        </Col>
      )}
      {size === "Velika" && (
        <Col
          style={{ marginTop: "30px" }}
          className="d-flex justify-content-center"
        >
          <img
            id="umrlica-icon"
            style={{
              height: "60px",
              width: "60px",
              border: "none",
              marginBottom: "1%",
            }}
            src={icon}
            alt="x"
          />
        </Col>
      )}
      {type === "Pomen" && (
        <p style={{ textAlign: "center", color: "gray", paddingTop: "1%" }}>
          {headerText}
        </p>
      )}
      <Row>
        <Col className="d-flex justify-content-around"></Col>
        {size !== "Najmanja" &&
          (type !== "Pomen" || type !== "Poslednji pozdrav") && (
            <Col className="d-flex justify-content-around">
              <img
                style={{
                  marginTop: "5%",
                  width: "110px",
                  height: "130px",
                  border: "3px solid black",
                }}
                src={"https://radojicictijanaa.pythonanywhere.com/" + image}
              />{" "}
            </Col>
          )}
        <Col className="d-flex justify-content-around"></Col>
      </Row>
      <Row style={{ paddingTop: "1%" }}>
        <Col
          style={{
            fontWeight: "bold",
            letterSpacing: "1.2px",
            textAlign: "center",
          }}
          className="d-flex justify-content-around"
        >
          {name}
        </Col>
      </Row>
      <Col className="d-flex justify-content-around">
        <span style={{ fontSize: "small", paddingBottom: "3%" }}>
          {birthDate} -{deathDate}
        </span>
      </Col>
      {size === "Srednja" && (
        <Row>
          {type === "Umrlica" && (
            <p style={{ padding: "3%", paddingLeft: "5%" }}>{main_text}</p>
          )}
          {type === "Pomen" && (
            <p style={{ padding: "3%", paddingLeft: "5%" }}>{main_text}</p>
          )}
          {type === "Poslednji pozdrav" && (
            <p
              style={{ padding: "3%", textAlign: "center", paddingLeft: "5%" }}
            >
              {main_text}
            </p>
          )}
        </Row>
      )}
      {size === "Velika" && (
        <Row>
          {type === "Umrlica" && (
            <p style={{ padding: "3%", paddingLeft: "5%" }}>{main_text}</p>
          )}
          {type === "Pomen" && (
            <p style={{ padding: "3%", paddingLeft: "5%" }}>{main_text}</p>
          )}
          {type === "Poslednji pozdrav" && (
            <p
              style={{ padding: "3%", textAlign: "center", paddingLeft: "5%" }}
            >
              {main_text}
            </p>
          )}
        </Row>
      )}
      {size === "Najmanja" && (
        <Row>
          {type === "Umrlica" && (
            <p style={{ textAlign: "center" }}>{main_text}</p>
          )}
          {type === "Pomen" && (
            <p style={{ textAlign: "center" }}>{main_text}</p>
          )}
          {type === "Poslednji pozdrav" && (
            <p
              style={{ padding: "3%", textAlign: "center", paddingLeft: "5%" }}
            >
              {main_text}
            </p>
          )}
        </Row>
      )}
      {size === "Srednja" && (
        <Row>
          {type === "Umrlica" && (
            <h5 style={{ paddingLeft: "5%" }} id="sakrij">
              Ozalošceni:
            </h5>
          )}
          {type === "Umrlica" && (
            <p style={{ paddingLeft: "5%" }} id="sakrij">
              {bottom_text}
            </p>
          )}
          {type === "Pomen" && (
            <p style={{ paddingLeft: "5%" }} id="sakrij">
              {bottom_text}
            </p>
          )}
          {type === "Poslednji pozdrav" && (
            <p style={{ textAlign: "right", paddingRight: "5%" }} id="sakrij">
              {bottom_text}
            </p>
          )}
        </Row>
      )}{" "}
      {size === "Velika" && (
        <Row>
          {type === "Umrlica" && (
            <Row style={{ padding: "2%", paddingLeft: "0" }}>
              <b>
                <h5 style={{ paddingLeft: "5%" }}>Ozalosceni:</h5>
                <p style={{ paddingLeft: "5%" }}>{bottom_text}</p>
              </b>
            </Row>
          )}
          {type === "Pomen" && (
            <p
              style={{
                textAlign: "right",
                fontWeight: "bold",
                paddingRight: "5%",
              }}
              id="sakrij"
            >
              {bottom_text}
            </p>
          )}

          {type === "Poslednji pozdrav" && (
            <p style={{ textAlign: "right", paddingRight: "5%" }} id="sakrij">
              {bottom_text}
            </p>
          )}
        </Row>
      )}
      {type === "Umrlica" && size === "Mala" && (
        <div>
          <Row style={{ padding: "2%", paddingLeft: "0" }}>
            <b>
              <p style={{ marginLeft: "5%", fontSize: "small" }}>{main_text}</p>
            </b>
          </Row>
          <Row style={{ padding: "2%", paddingLeft: "0" }}>
            <b>
              <span style={{ fontWeight: "normal", marginLeft: "5%" }}>
                Ozalosceni:
              </span>
              <p style={{ marginLeft: "5%", fontSize: "small" }}>
                {bottom_text}
              </p>
            </b>
          </Row>
        </div>
      )}
      {type === "Poslednji pozdrav" && size === "Mala" && (
        <div>
          <Row style={{ padding: "2%", paddingLeft: "0" }}>
            <b>
              <p style={{ marginLeft: "5%", fontSize: "small" }}>{main_text}</p>
            </b>
          </Row>

          <Row style={{ padding: "2%", paddingLeft: "5%" }}>
            <hr style={{ margin: "0", marginBottom: "1%" }}></hr>
            <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
              Ozalosceni {">>"}
            </span>

            <p style={{ fontWeight: "bold", paddingTop: "1%" }}>
              {bottom_text}
            </p>
          </Row>
        </div>
      )}
    </Container>
  );
};

export default SubmitFormPreview;
